module.exports = __webpack_public_path__ + "media/images/doctor_default-28e6768721352754fe6795338b92fee7.svg";